module.exports = __webpack_public_path__ + "static/media/RR-1.4ce6af65.png";